// ─── Údaje o podnikateli a kontakt ────────────────────────────────────────
// Jediné místo pro jméno, IČO, adresu, e-mail a telefon – používá je patička
// webu i Zásady ochrany osobních údajů.
//
// Podle § 435 občanského zákoníku má podnikatel na webu uvést jméno, IČO
// a sídlo / místo podnikání a u živnostníka i údaj o zápisu do rejstříku.
// Když je hodnota null, řádek se na webu nezobrazí (údaj o zápisu patří k IČO).

export const OWNER_NAME = 'Eva Kodytková';

/** IČO (od Evy 12. 10. 2026) */
export const ICO: string | null = '03463991';

/** Místo podnikání (adresa z živnostenského rejstříku) */
export const BUSINESS_ADDRESS: string | null = 'Tylova 960, 564 01 Žamberk';

/** Údaj o zápisu – zobrazí se spolu s IČO. */
export const REGISTRATION_NOTE =
  'Fyzická osoba podnikající dle živnostenského zákona, zapsaná v živnostenském rejstříku';

/**
 * Kontaktní e-mail – sem chodí poptávky z formuláře (stejná adresa je
 * v backendu), takže je ověřeně čtený. Používá se i pro žádosti podle GDPR.
 * Schránka je u Gmailu, proto Zásady (PrivacyPolicy.tsx, sekce Příjemci)
 * uvádějí Google – při změně adresy na jiného poskytovatele upravit i tam.
 */
export const CONTACT_EMAIL = 'hrachovenachova@gmail.com';

export const CONTACT_PHONE = '+420 774 239 849';

/** Telefon pro odkaz tel: – jen číslice a „+“ */
export const CONTACT_PHONE_HREF = `tel:${CONTACT_PHONE.replace(/[^\d+]/g, '')}`;
